import { RequestStatus, defaults } from 'typed/api';
import { NetworkSynchronizable } from 'typed/api/entities';
import { Action, ActionType } from 'typed/actions';
import { IReducer } from './';
import { DeepPartial, deepAssign, deepClone } from 'typed/utils';
import { REDUCER_EXPIRATION_TIMEOUT, SESSION_EXPIRATION_TIMEOUT } from 'utils/constants';

const SESSION_ENTITY_TYPE = (defaults as any).SessionInformation.EntityType;

export default function networkActionReducer<T extends ActionType, S extends NetworkSynchronizable>(type: T): (state: S, action: Action<T>) => S;
export default function networkActionReducer<T extends ActionType, S extends NetworkSynchronizable>(def: S, type: T): IReducer<S, Action<T>>;
export default function networkActionReducer<T extends ActionType, S extends NetworkSynchronizable>(...args: any[]): IReducer<S, Action<T>> {
    const [def, type]: [S | undefined, T] = args.length === 1 ? [, args[0]] : args as [any, any];
    return function networkActionReducer(state = deepClone(def)!, action) {
        if (action.type === type) {
            switch (action.payload.status) {
                case RequestStatus.PENDING:
                    return deepAssign(state, { Custom: { status: action.payload.status } } as DeepPartial<S>);

                case RequestStatus.SUCCEEDED:
                    const
                        isStateSet = state !== undefined && state !== null,
                        isSessionState = isStateSet && Object.prototype.hasOwnProperty.call(state, 'EntityType') && (state as any).EntityType === SESSION_ENTITY_TYPE,
                        expirationDate = new Date(+new Date() + (isSessionState ? SESSION_EXPIRATION_TIMEOUT : REDUCER_EXPIRATION_TIMEOUT));

                    return deepAssign(state, { Custom: { status: action.payload.status, expires: expirationDate } } as DeepPartial<S>);

                case RequestStatus.FAILED:
                    return deepAssign(state, { Custom: { ...state.Custom, status: action.payload.status, expires: new Date() } } as DeepPartial<S>);

                default:
                    return state;
            }
        }

        return state;
    };
}
